export const RequisitionRouting = [
  {
    path: "/material/requisition/list",
    name: "material-requisition-list",
    meta: { title: "项目领料申请" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-requisition" */ "@/views/material/requisition/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/requisition/create",
    name: "material-requisition-create",
    meta: { title: "新增项目领料申请", comName: "MaterialRequisitionFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-requisition" */ "@/views/material/requisition/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/requisition/edit/:id",
    name: "material-requisition-edit",
    meta: { title: "编辑项目领料申请", comName: "MaterialRequisitionFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-requisition" */ "@/views/material/requisition/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/requisition/detail/:id",
    name: "material-requisition-detail",
    meta: { title: "项目领料申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-requisition" */ "@/views/material/requisition/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/requisition/flowPrint/:id",
    name: "material-requisition-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/material/requisition/flow-print/index.vue"
      ),
  },
];
